import React from "react"

import { Box } from "@mui/material"

import {
	PageHeader,
	PageSectionTitle,
	RoutesData,
} from "components/commons"
import {
	FavouriteAssetsTable,
	FavouritesAdvancedSearch,
} from "components/favourites"
import {AssetFilter, PaginatedResponse, SearchFilter} from "../../models";
import {FavouriteServices} from "../../services/favourite.services";
import {ErrorResponse, Loading, RestResponse} from "@sinossi/mates-react-library";
import {FavouriteResponse} from "../../models/favourite";
import {MatesComponent, MatesComponentState} from "../../components/mates-component";
import withUseRouter, {UseRouterParams} from "../../services/router";

interface FavouritesProps extends UseRouterParams
{
}
interface FavouritesState extends MatesComponentState
{
	loading: boolean
	request: AssetFilter
	pagination: {pageSize: number, pageId: number}
	data: PaginatedResponse<FavouriteResponse> | null
}
class Favourites extends React.Component<FavouritesProps, FavouritesState>
{
	private readonly matesComponent: MatesComponent<FavouritesProps, FavouritesState> = new MatesComponent(this)

	constructor(props: FavouritesProps)
	{
		super(props)
		this.state = {
			...this.matesComponent.setupState(),
			loading: true,
			pagination: {
				pageSize: 10,
				pageId: 0
			},
			request: new AssetFilter(),
			data: null
		}
	}

	componentDidMount() {
		this.getFavourite()
	}

	private handleSearchbarCallback = (data: AssetFilter): void => {
		this.setState(() => ({
			loading: true,
			request: {
				...data,
				pageId: 0,
				pageSize: this.state.pagination.pageSize
			},
			pagination: {
				pageId: 0,
				pageSize: this.state.pagination.pageSize,
			}
		}), this.getFavourite)
	}


	private getFavourite = (pagination?: SearchFilter) => {
		if(pagination){
			this.setState(() => ({
				request: {
					...this.state.request,
					pageSize: pagination.pageSize,
					pageId: pagination.pageId
				},
				loading: true
			}), () => FavouriteServices.getFavourite(this.state.request, this.getFavouriteCallback, this.matesComponent.onError))
		}

		FavouriteServices.getFavourite(this.state.request, this.getFavouriteCallback, this.matesComponent.onError)
	}

	private getFavouriteCallback = (response: RestResponse<any, ErrorResponse>) => {
		if (response.hasError()) {
			this.setState(() => ({
				loading: false
			}))
			this.matesComponent.onError(response)
			return
		}

		if (response.data) {
			let dataItems: FavouriteResponse[] = response.data.items
			dataItems.map((item, index) => {
				item.id = index
			})

			let data: PaginatedResponse<FavouriteResponse> = {
				items: dataItems,
				pagination: response.data.pagination
			}

			this.setState(() => ({
				loading: false,
				data: data
			}))
		}
	}


	render() {
		return (
			<Box sx={{ width: "100%", pt: 2, position: "relative", }}>
				<PageHeader
					title={RoutesData.FAVOURITES.title}
					paths={[ RoutesData.DASHBOARD, RoutesData.FAVOURITES ]}
				/>
				<Loading show={this.state.loading} />
				{
					!this.state.loading &&
					<>
						{/*<FavouritesAdvancedSearch handleCallback={this.handleSearchbarCallback}/>*/}

						<Box sx={{ mt: 3 }}>
							<PageSectionTitle title={RoutesData.FAVOURITES.title} />
							{
								this.state.data &&
								<FavouriteAssetsTable data={this.state.data} getFavourite={this.getFavourite}/>
							}
						</Box>
					</>
				}
			</Box>
		)
	}
}

export default withUseRouter(Favourites)
